import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { ClickableBox, Typography } from '../../../ui-kit';
import { Color } from '../../../generated/graphql';
import { CategoryColorMarker } from './style';

export interface NameCellProps {
    content: string | number;
    color?: Color;
    isChild?: boolean;
    childCount?: number;
    hasCollapsibleContent?: boolean;
    isOpen?: boolean;
    setIsOpen?(): void;
}

const NameCell = ({ content, color, isChild, isOpen, childCount, setIsOpen, hasCollapsibleContent }: NameCellProps) => {
    return (
        <ClickableBox
            display='flex'
            ml={isChild ? 4 : 0}
            maxHeight={hasCollapsibleContent ? '18.375px' : undefined}
            alignItems='center'
            onClick={hasCollapsibleContent ? setIsOpen : undefined}
        >
            {color ? <CategoryColorMarker isChild={isChild} color={color} /> : null}
            <Tooltip title={content}>
                <Typography variant='subtitle1' fontWeight={isChild ? 'medium' : undefined} noWrap>
                    {content}
                    {childCount ? ` (${childCount})` : null}
                </Typography>
            </Tooltip>
            {hasCollapsibleContent
                ? (
                    <IconButton
                        aria-label="expand row"
                        size="small"
                    >
                        {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                ) : null}
        </ClickableBox>
    );
};

export default NameCell;
